import { gql } from '@apollo/client'

export const Query = gql`
  query MaintenanceEvents($companyId: ID!, $filters: MaintenanceEventFilters, $order: MaintenanceEventOrder, $after: String, $before: String, $first: Int, $last: Int) {
    maintenanceEvents(companyId: $companyId, filters: $filters, order: $order, after: $after, before: $before, first: $first, last: $last) {
      nodes {
        id
        maintenanceType { id name color }
        maintenanceSchedule { id summary }
        asset { id name }
        dueAt
        startedAt
        result
        state
      }
      pageInfo { startCursor endCursor hasNextPage hasPreviousPage }
    }
  }
`
